/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Downloaddocuments1Inputs */

const en_btn_downloaddocuments1 = /** @type {(inputs: Btn_Downloaddocuments1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download documents`)
};

/**
* | output |
* | --- |
* | "Download documents" |
*
* @param {Btn_Downloaddocuments1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_downloaddocuments1 = /** @type {((inputs?: Btn_Downloaddocuments1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Downloaddocuments1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_downloaddocuments1(inputs)
});
export { btn_downloaddocuments1 as "btn_downloadDocuments" }